import { axiosErrorUnwrap } from "src/utils/axiosError";
import axios, { AxiosResponse } from "axios";
import { RequestBody } from "src/web-api/types/affiliate";

interface RegisterAffiliateParams extends RequestBody {}

interface RegisterAffiliateRes {
  sRefCode: string;
}

export const getAffiliateReport = async (): Promise<any> => {
  try {
    const res = await axios.get<any>("/api/affiliate-service/report");
    return res.data;
  } catch (error) {
    const errorUnwrap = axiosErrorUnwrap(error);
    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
  }
};

export const registerAffiliate = async (
  value: RegisterAffiliateParams
): Promise<RegisterAffiliateRes> => {
  try {
    const res: AxiosResponse<RegisterAffiliateRes> = await axios.post<any>(
      "/api/retail/affiliate",
      value
    );
    return res.data;
  } catch (error) {
    const errorUnwrap = axiosErrorUnwrap(error);
    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
  }
};
